import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { MenuItem } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {MODEL_MEASUREMENT_UNIT} from '../Model/Models';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IngredientsFields = ({ item, measurementUnitsAll, disabled, emptyFields, handleChange, errorCode, errorName }) => {

    const { t } = useTranslation();

    return (<>
        <div className='col-12'>
            <CustomTextField
                id='txt_if_name'
                name='name'
                value={item?.name}
                trans='name'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorName}
                isValidText='the_value_already_exists'
                required={true}
            />
        </div>
        <div className='col-sm-12 col-xxl-6 col-lg-6'>
            <CustomTextField
                id='txt_if_code'
                name='code'
                value={item?.code}
                trans='item_code'
                type={'text'}
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorCode}
                isValidText='the_value_already_exists'
                required={true}
                length={16}
            />
        </div>
        <div className='col-sm-12 col-xxl-6 col-lg-6'>
            <CustomSelectAndChildren
                id='slt_if_unit_of_measure'
                name='measurementUnitId'
                trans='unit_of_measure'
                disabled={disabled}
                onChange={handleChange}
                value={item?.measurementUnitId || ''}
                emptyFields={emptyFields}
                required={true}
                showNoSelectionOption={false}
            >
                {measurementUnitsAll
                    ?.filter(unit =>
                        Object.values(MODEL_MEASUREMENT_UNIT).some(model => model.id === unit.id)
                    )
                    .map(unit => {
                        const modelUnit = Object.values(MODEL_MEASUREMENT_UNIT).find(model => model.id === unit.id);
                        return (
                            <MenuItem key={unit.id} value={unit.id}>
                                {t(modelUnit.trans)}
                            </MenuItem>
                        );
                    })}
            </CustomSelectAndChildren>
        </div>
        <div className='col-sm-12 col-xxl-12 col-lg-12'>
            <CustomTextField
                id='txt_if_description'
                name='description'
                value={item?.description}
                trans='description'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                multiline={true}
                length={512}
            />
        </div>
    </>)
}

export default IngredientsFields;
